function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShorttext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.05888 19.4642C3.80531 19.4642 3.59341 19.3785 3.42317 19.2071C3.25293 19.0356 3.16722 18.8231 3.16603 18.5696C3.16484 18.316 3.25055 18.1041 3.42317 17.9338C3.59579 17.7636 3.80769 17.6785 4.05888 17.6785H16.5589C16.8124 17.6785 17.0243 17.7642 17.1946 17.9356C17.3648 18.1071 17.4505 18.3196 17.4517 18.5731C17.4529 18.8267 17.3672 19.0386 17.1946 19.2088C17.022 19.3791 16.8101 19.4642 16.5589 19.4642H4.05888ZM4.05888 12.3214C3.80531 12.3214 3.59341 12.2356 3.42317 12.0642C3.25293 11.8928 3.16722 11.6803 3.16603 11.4267C3.16484 11.1731 3.25055 10.9612 3.42317 10.791C3.59579 10.6208 3.80769 10.5356 4.05888 10.5356H27.2731C27.5267 10.5356 27.7386 10.6214 27.9088 10.7928C28.0791 10.9642 28.1648 11.1767 28.166 11.4303C28.1672 11.6839 28.0815 11.8958 27.9088 12.066C27.7362 12.2362 27.5243 12.3214 27.2731 12.3214H4.05888Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorttext);
export default __webpack_public_path__ + "static/media/shorttext.80fddc216494f696db2d6282e9ebd502.svg";
export { ForwardRef as ReactComponent };